import { useContext, createContext } from 'react';

export const NewPostContext = createContext(null);

export function useNewPostContext() {
  return useContext(NewPostContext);
}
